export default __webpack_public_path__ + "static/media/pattern.390c8b64.png";